// Mock data for the chemical marketplace

export const featuredFactories = [
  {
    id: 1,
    name: 'Guangdong Chemical Industries',
    location: 'Guangdong, China',
    rating: 4.8,
    verified: true,
    image: 'https://images.unsplash.com/photo-1565043666747-69f6646db940?w=400&h=300&fit=crop',
    specialties: ['Organic Chemicals', 'Petrochemicals'],
    responseTime: '< 2 hours'
  },
  {
    id: 2,
    name: 'BASF India Ltd',
    location: 'Mumbai, India',
    rating: 4.9,
    verified: true,
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop',
    specialties: ['Specialty Chemicals', 'Performance Products'],
    responseTime: '< 1 hour'
  },
  {
    id: 3,
    name: 'Tokyo Fine Chemicals',
    location: 'Tokyo, Japan',
    rating: 4.7,
    verified: true,
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=400&h=300&fit=crop',
    specialties: ['Pharma Intermediates', 'Electronic Chemicals'],
    responseTime: '< 3 hours'
  },
  {
    id: 4,
    name: 'EuroChem Trading',
    location: 'Rotterdam, Netherlands',
    rating: 4.6,
    verified: true,
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    specialties: ['Fertilizers', 'Industrial Chemicals'],
    responseTime: '< 4 hours'
  },
  {
    id: 5,
    name: 'American ChemCorp',
    location: 'Houston, USA',
    rating: 4.8,
    verified: true,
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&h=300&fit=crop',
    specialties: ['Bulk Chemicals', 'Agrochemicals'],
    responseTime: '< 2 hours'
  }
];

export const hotProducts = [
  {
    id: 1,
    name: 'Sodium Lauryl Sulfate (SLS)',
    casNumber: '151-21-3',
    purity: '99%',
    supplier: 'Guangdong Chemicals',
    image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=300&h=300&fit=crop',
    category: 'Surfactant'
  },
  {
    id: 2,
    name: 'Acetone',
    casNumber: '67-64-1',
    purity: '99.5%',
    supplier: 'BASF India',
    image: 'https://images.unsplash.com/photo-1627297504751-f0c5e5e5e5e5?w=300&h=300&fit=crop',
    category: 'Solvent'
  },
  {
    id: 3,
    name: 'Sodium Hydroxide',
    casNumber: '1310-73-2',
    purity: '98%',
    supplier: 'EuroChem Trading',
    image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=300&h=300&fit=crop',
    category: 'Inorganic'
  },
  {
    id: 4,
    name: 'Toluene',
    casNumber: '108-88-3',
    purity: '99.8%',
    supplier: 'Tokyo Fine Chemicals',
    image: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=300&h=300&fit=crop',
    category: 'Solvent'
  },
  {
    id: 5,
    name: 'Ethanol (Anhydrous)',
    casNumber: '64-17-5',
    purity: '99.9%',
    supplier: 'American ChemCorp',
    image: 'https://images.unsplash.com/photo-1603251579431-8041402bdeda?w=300&h=300&fit=crop',
    category: 'Solvent'
  },
  {
    id: 6,
    name: 'Sulfuric Acid',
    casNumber: '7664-93-9',
    purity: '98%',
    supplier: 'BASF India',
    image: 'https://images.unsplash.com/photo-1611223596748-fafc2b7e6c0e?w=300&h=300&fit=crop',
    category: 'Inorganic'
  },
  {
    id: 7,
    name: 'Citric Acid',
    casNumber: '77-92-9',
    purity: '99.5%',
    supplier: 'Guangdong Chemicals',
    image: 'https://images.unsplash.com/photo-1584036561566-b463141893c5?w=300&h=300&fit=crop',
    category: 'Organic'
  },
  {
    id: 8,
    name: 'Methanol',
    casNumber: '67-56-1',
    purity: '99.9%',
    supplier: 'EuroChem Trading',
    image: 'https://images.unsplash.com/photo-1628771065518-0d82f1938462?w=300&h=300&fit=crop',
    category: 'Solvent'
  }
];

export const marketTrends = {
  importData: {
    labels: ['China', 'USA', 'Germany', 'Japan', 'S. Korea'],
    datasets: [
      {
        label: 'Imports (MT)',
        data: [4500, 3200, 2100, 1800, 1500],
        backgroundColor: [
          'rgba(59, 130, 246, 0.8)',
          'rgba(6, 182, 212, 0.8)',
          'rgba(99, 102, 241, 0.8)',
          'rgba(139, 92, 246, 0.8)',
          'rgba(168, 85, 247, 0.8)'
        ],
        borderRadius: 8
      }
    ]
  }
};

export const applications = [
  {
    id: 1,
    name: 'Pharmaceuticals',
    icon: '💊',
    description: 'APIs, excipients, and intermediates',
    productCount: 8500,
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=300&fit=crop'
  },
  {
    id: 2,
    name: 'Textiles',
    icon: '🧵',
    description: 'Dyes, auxiliaries, and finishing agents',
    productCount: 4200,
    image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=400&h=300&fit=crop'
  },
  {
    id: 3,
    name: 'Agriculture',
    icon: '🌱',
    description: 'Fertilizers, pesticides, and nutrients',
    productCount: 6300,
    image: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=400&h=300&fit=crop'
  },
  {
    id: 4,
    name: 'Paints & Coatings',
    icon: '🎨',
    description: 'Pigments, resins, and solvents',
    productCount: 3100,
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=400&h=300&fit=crop'
  }
];
